import React, { useEffect, useState } from 'react';
import { useHeader } from '../header';
import { useVendorService } from '../services/vendor';
import { useProductService } from '../services/product';
import { Vendor } from '../services/vendor/types';
import { ProductCategory } from '../services/product/types';
import { HowToBanner, ProductGrid, StoreGrid } from './index';
import { BounceLoader } from '../loader';
import { DeeplinkModalProvider } from '../modal';

const RewardsDashboard = () => {
    const { setHeaderTitle, setHeaderSubTitle } = useHeader();
    const vendorService = useVendorService();
    const productService = useProductService();
    // const { activatePromo, deactivatePromo } = useExtension();
  
    const [stores, setStores] = useState<Vendor[]>([]);
    const [productCategories, setProductCategories] = useState<ProductCategory[]>([]);

    const [showStores, setShowStores] = useState(false);

    useEffect(() => {
        setHeaderTitle('Shop and earn');
        setHeaderSubTitle('Activate a store, shop as normal, earn automatically');
        // activatePromo();

        Promise.all([
            vendorService.searchVendors(),
            productService.getProductCategoryList(),
        ]).then(([vendors, categories]) => {
            setStores(vendors);
            setProductCategories(categories);
        });

        // return () => deactivatePromo();
    }, []);

    return (
        <div className="light-mode">
            {!productCategories.length ?
                <BounceLoader title="Loading shop" subTitle="Fetching categories..." />
                :
                <DeeplinkModalProvider>
                    <HowToBanner />
                    <div className="spp-tab-toggle">
                        <button
                            className={`spp-tab-btn ${!showStores ? 'spp-tab-btn--active' : ''}`}
                            onClick={() => setShowStores(false)}
                        >
                            Products
                        </button>
                        <button
                            className={`spp-tab-btn ${showStores ? 'spp-tab-btn--active' : ''}`}
                            onClick={() => setShowStores(true)}
                        >
                            Stores
                        </button>
                    </div>
                        {showStores ? (
                            <StoreGrid stores={stores} />
                        ) : (
                            <ProductGrid categories={productCategories} />
                        )}
                </DeeplinkModalProvider>
            }
        </div>
    );
};

export default RewardsDashboard;